import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "age-gate"
}
const _hoisted_2 = { class: "age-card" }
const _hoisted_3 = { class: "age-title" }
const _hoisted_4 = { class: "age-text" }
const _hoisted_5 = { class: "age-subtext" }
const _hoisted_6 = { class: "age-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "age-badge" }, "18+", -1)),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.jsonData.ageGateTitle), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.jsonData.ageGateText), 1),
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.jsonData.ageGateSocial) + " ", 1),
            _createVNode(_component_router_link, { to: "/terms" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.jsonData.ageGateTermsLink), 1)
              ]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createTextVNode(". "))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "age-btn age-btn--confirm",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, _toDisplayString(_ctx.jsonData.ageGateConfirm), 1),
            _createElementVNode("button", {
              class: "age-btn age-btn--decline",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args)))
            }, _toDisplayString(_ctx.jsonData.ageGateDecline), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}